import types from './types';
import update from '../../../../utilities/updateStateUtilities';
import PlanPageConstants from '../PlanPageConstants';

const INITIAL_STATE = {
    // Data properties
    checkingOutId: null,
    tunebatPromotionCode: null,
    updatingSubscriptionId: null,

    // The currently selected period on the plans page
    periodType: PlanPageConstants.PERIOD_TYPES.YEARLY,

    // The video quality of the pro plan on the plans page
    selectedProPlanVideoQuality: PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS,

    // The  video quality of the lower plan in the cancellation window
    cheaperProPlanVideoQuality: PlanPageConstants.PURCHASE_OPTION_VIDEO_QUALITY.TEN_EIGHTY_P_60FPS,

    // Progress flags
    updatingSubscription: false,
    cancelingSubscription: false,
    reactivatingSubscription: false,
    pausingSubscription: false,
    unpausingSubscription: false
}

const planReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case types.SET_PROPERTY: {
            return update.set(state, action.key, action.value);
        }
        // TODO: Can be optimized with setProperty using
        case types.SET_CHECKING_OUT_ID: {
            return {
                ...state,
                checkingOutId: action.id
            }
        }
        // TODO: Can be optimized with setProperty using
        case types.SET_CANCELING_SUBSCRIPTION: {
            return {
                ...state,
                cancelingSubscription: action.isCanceling
            }
        }
        // TODO: Can be optimized with setProperty using
        case types.SET_REACTIVATING_SUBSCRIPTION: {
            return {
                ...state,
                reactivatingSubscription: action.isReactivating
            }
        }
        // TODO: Can be optimized with setProperty using
        case types.SET_PAUSING_SUBSCRIPTION: {
            return {
                ...state,
                pausingSubscription: action.isPausing
            }
        }
        // TODO: Can be optimized with setProperty using
        case types.SET_UNPAUSING_SUBSCRIPTION: {
            return {
                ...state,
                unpausingSubscription: action.isUnpausing
            }
        }
        // TODO: Can be optimized with setProperty using
        case types.SET_UPDATING_SUBSCRIPTION_ID: {
            return {
                ...state,
                updatingSubscriptionId: action.id
            }
        }

        default: return state;
    }
}

export default planReducer;